var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSportsicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.925 2.575H11.2V2H4.3V2.575H2.575C2.23 2.575 2 2.805 2 3.15V4.53C2 5.8525 2.9775 6.945 4.3 7.1175V7.175C4.3 8.8425 5.45 10.2225 7.0025 10.5675L6.6 11.775H5.2775C5.0475 11.775 4.8175 11.9475 4.76 12.1775L4.3 13.5H11.2L10.74 12.1775C10.6825 11.9475 10.4525 11.775 10.2225 11.775H8.9L8.4975 10.5675C10.05 10.2225 11.2 8.8425 11.2 7.175V7.1175C12.5225 6.945 13.5 5.8525 13.5 4.53V3.15C13.5 2.805 13.27 2.575 12.925 2.575ZM4.3 5.9675C3.6675 5.795 3.15 5.22 3.15 4.53V3.725H4.3V5.9675ZM8.9 7.75L7.75 7.1175L6.6 7.75L6.8875 6.6L6.025 5.45H7.2325L7.75 4.3L8.2675 5.45H9.475L8.6125 6.6L8.9 7.75ZM12.35 4.53C12.35 5.22 11.8325 5.8525 11.2 5.9675V3.725H12.35V4.53Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsicon);
export default __webpack_public_path__ + "static/media/sportsicon.1ba3f1917f302a35617f34feab4fcb44.svg";
export { ForwardRef as ReactComponent };